import PropTypes from "prop-types"
import React, { useEffect } from "react"

import {
  Row,
  Col,
  // CardBody,
  // Card,
  Alert,
  // Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Spinner,
} from "reactstrap"

// Redux
import { Link, useLocation, useNavigate } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// import images
import logo from "../../assets/images/logo-dark.png"
import logoLg from "assets/images/header-logo-lg.svg"

import SocialLink from "./SocialLink/SocialLink"
import { post } from "../../api/axios"
import endpoints from "../../api/endpoints"
import { setAuth, setLogin, setUser } from "../../store/slices/authSlice"
import { useDispatch } from "react-redux"
import { Bounce, toast } from "react-toastify"

const PayPalSuccess = props => {
  document.title = " PayPalSuccess | Dock Tok"

  // const dispatch = useDispatch()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const queryString = location.search
  const params = new URLSearchParams(queryString)
  const payPalSuccessResp = async () => {
    try {
      const response = await post(`${endpoints.subscription}/verify`, {
        subscription_id: params.get("subscription_id"),
        ba_token: params.get("ba_token"),
        token: params.get("token"),
      })
      console.log("Subscription", response.data)
      if (response.data.subscriptionDetails.status === "ACTIVE") {
        toast.success("Subscription activated successfully!", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })

        dispatch(setUser(response.data.data.user))
        dispatch(setAuth(true))
        navigate("/dashboard")
      } else {
        toast.error("Subscription activation failed.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })
      }
    } catch (error) {
      console.error(error, "Subscription activation failed")
    }
  }
  const userData = (tokens, credType) => {
    // localStorage.setItem("accessToken", tokens?.token)
    // dispatch(
    //   setLogin({
    //     currentUser: tokens?.data?.user,
    //     jid: tokens?.token,
    //     isAuth: true,
    //     loginType: credType,
    //   })
    // )
    // navigate("/dashboard")
    // toast.success("Login Successful", {
    //   position: "bottom-center",
    //   theme: "colored",
    //   transition: Bounce,
    // })
  }

  // http://localhost:3000/paypalsuccess?subscription_id=I-3150R7KR0XB8&ba_token=BA-77F98322B81020250&token=3A95863154751582L
  useEffect(() => {
    payPalSuccessResp()
    document.body.className = "authentication-bg"

    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = ""
    }
  }, [])

  return (
    <Row className="px-md-5">
      <Col lg={12}>
        <div className="text-center">
          <Link to="/" className="mb-sm-3 mt-5 d-block auth-logo">
            <img src={logo} alt="" height="80" className="logo logo-light" />
            <img src={logoLg} alt="" height="80" className="logo logo-dark" />
          </Link>
        </div>
      </Col>
      <Col xs="12" lg="12">
        <div className="text-center mt-2">
          <h5 className="text-primary text-uppercase">Paypal Subscription</h5>
          <p className="text-muted">We are verifying your data...</p>
          <div className="p-2 mt-4 ">
            <Spinner>Loading...</Spinner>
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default withRouter(PayPalSuccess)

PayPalSuccess.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
